export const getallmasterlist = "getallmasterlist";
export const getallmasterlistbycountry = "getallmasterlistbycountry";
// import { mdmflags } from '@constants/endpoints';
export const getAllEndpoints = "";
export const gettargetprogram = "gettargetprogram";
export const getsubscriptionfor = "getsubscriptionfor";
export const requestforinfo = "requestforinfo";
export const getorganisationmasterlist = "getorganisationmasterlist";
export const masterdataconfigurations = "masterdataconfigurationsnew";
export const fetchSubSystems = "fetchSubSystemsnew";
export const masterdatacollections = "masterdatacollections";
export const entityResolution = "entityResolution";
export const fetchemumasterslist = "fetchemumasterslist";
export const emumasterdata = "emumasterdata";
export const fetchMethodByCategory = "fetchMethodByCategory";
export const emugenericdata = "emugenericdata";
export const getorganisationunit = "getorganisationunit";
export const mysubscription = "mysubscription";
export const usersession = "usersession";
export const usermanagement = "usermanagement";
export const customrolesuam = "customrolesuam";
export const fileupload = "fileupload";
export const users = "users";
export const user = "user";
export const cronjob = "cronjob";
export const levelmasters = "levelmasters";
export const getPowerbiReports = "getPowerbiReports";
export const fetchsubmethodbymethod = "fetchsubmethodbymethod";
export const emufactordata = "emufactordata";
export const newregistration = "newregistration";
export const cancelsubscription = "cancelsubscription";
export const cancelorganisationsubscription = "cancelorganisationsubscription";
export const programtypemaster = "programtypemaster";
export const sourcetypemaster = "sourcetypemaster";
export const resourcetypemaster = "resourcetypemaster";
export const sourcesystemmaster = "sourcesystemmaster";
export const updateuserstatus = "updateuserstatus";
export const survey = "survey";
export const surveylogs = "surveylogs";
export const activatesubscription = "activatesubscription";
export const getsurveytype = "getsurveytype";
export const deletesurvey = "deletesurvey";
export const surveyapidata = "surveyapidata";
export const changePassword = "changePassword";
export const dataValidator = "dataValidator";
export const getDHISData = "getDHISData";
export const facilityregistryupload = "facilityregistryuploadnew";
export const updateReconValue = "master/updateReconValue";
export const resolveEntity = "entity/resolveOrgEntityExceptions";
export const messagelibrary = "messagelibrary";
export const settings = "settings";
export const masterfileuploadlogs = "masterfileuploadlogsnew";
export const resendEmail = "resendEmail";
export const tablemapper = "tablemapper";
export const tableMapper = "tableMapper";
export const emailtemplates = "emailtemplates";
export const rules = "rules";
export const dwschemadetails = "dwschemadetails";
export const testQuery = "testQuery";
export const ruleBasedAlertsServer = "get-rule-based-alerts";
// export const ruleBasedAlertsServer = "rule-based-alerts-server";
// export const ruleBasedAlertsServerDQ = "rule-based-alerts-dq-server";
export const ruleBasedAlertsSingle = "rule-based-alerts-single-json";
export const ruleBasedNotificationSingle =
  "rule-based-notification-single-json";
export const ruleBasedAlertRecords = "rule-based-alert-records-json";
export const executeBusiness = "generate-sql2";
export const executeDQ = "dqr-rid";
export const runrulecronjob = "runrulecronjob";
export const stoprulecronjob = "stoprulecronjob";
export const fetchcategorybyprogramtype = "fetchcategorybyprogramtype";
export const fetchsectorbycategory = "fetchsectorbycategory";
export const fetchFileUploadStatusnew = "fetchFileUploadStatusnew";
export const getMetaData = "getMetaData";
export const hpcounts = "hpcounts";
export const applicationconf = "applicationconf";
export const issourcesystemuploaded = "issourcesystemuploaded";
export const token = "token";
export const deactivateusers = "deactivateusers";
export const deactivatesubscribers = "deactivatesubscribers";
export const rejecteddeactivation = "rejecteddeactivation";
export const withdrawnUsers = "withdrawnUsers";
export const reactivationrequests = "reactivationrequests";
export const reactivatedusers = "reactivatedusers";
export const rejectedreactivation = "rejectedreactivation";
export const masterdatadetail = "entity/getMasterList";
export const customurl = "customurl";
export const mlProcess = "pythonService";
export const uniquesourcesystems = "uniquesourcesystems";
export const logout = "logout";
export const mdmflags = "mdmflags";
export const regparententities = "regparententities";
export const nologinusers = "nologinusers";
export const fetchemumonths = "fetchemumonths";
export const fetchspstatus = "fetchspstatus";
export const emucalculationsp = "emucalculationsp";
export const calculatefinancialaggsp = "calculatefinancialaggsp";
export const nonuamusers = "nonuamusers";
export const dataexchange = "dataexchange";
export const fhirResponse = "master/fhirResponse";
export const emuspmasterdata = "emuspmasterdata";
export const fetchbenchmarks = "fetchbenchmarks";
export const fetchstandarddeviation = "fetchstandarddeviation";
export const fetchcoeffOfdet = "fetchcoeffOfdet";
export const calculatereportingrate = "calculatereportingrate";
export const calculatestandarddeviation = "calculatestandarddeviation";
export const calculatecoeffofdet = "calculatecoeffofdet";
export const runEMUStoredProc = "entity/runEMUStoredProc";
export const fetchetljobstatus = "fetchetljobstatus";
export const dashboardlist = "dashboardlist";
export const diseasetypemaster = "diseasetypemaster";
export const loginapi = "authenticate/local";
export const diseasemaster = "diseasemaster";
export const constant = "constant";
export const expression = "expression";
export const orglist = "orglist";
export const fetchmasterorgunit = "fetchmasterorgunit";
export const apiconfigtestapi = "apiconfigtestapi";
export const fetchrolesmapping = "getRoleFlagMapping";
export const fetchusercreationstatus = "fetchusercreationstatus";
export const surveydataupload = "surveydataupload";
export const surveymetadataupload = "surveymetadataupload";
export const fetchmetadataexists = "fetchmetadataexists";
export const updatemetadata = "updatemetadata";
export const surveymetadatainsert = "surveymetadatainsert";
export const addsurveytype = "addsurveytype";
export const quesupload = "quesupload";
export const metadataconfiguration = "metadataconfiguration";
export const dateformat = "dateformat";
export const dateformatconf = "dateformatconf";
export const getSubscribers = "getSubscribers";
export const getActiveOrCancelledSubscribers ="getActiveOrCancelledSubscribers";
export const getPowerbiReportsFmoh = "getPowerbiReportsFmoh";
